const palette = {
  mooGreen: '#009870',
  mooGrey: '#4B596D',
};

export default {
  breakpoints: { keys: ['xs', 'sm', 'md', 'lg', 'xl'], values: { xs: 380, sm: 640, md: 1024, lg: 1440, xl: 1920 } },
  direction: 'ltr',
  mixins: {
    toolbar: {
      minHeight: 56,
      '@media (min-width:0px) and (orientation: landscape)': { minHeight: 48 },
      '@media (min-width:640px)': { minHeight: 64 },
    },
  },
  palette: {
    common: { black: '#000', white: '#fff' },
    type: 'light',
    primary: { main: palette.mooGreen, light: '#E6F5F1', dark: '#076049', contrastText: '#fff' },
    secondary: { main: palette.mooGrey, light: '#BFC5CD', dark: '#3A4655', contrastText: '#fff' },
    error: { main: '#FBE9EB', light: '#FBE9EB', dark: '#E77D88', contrastText: '#323c49' },
    warning: { main: '#fdf2d5', light: '#fdf2d5', dark: '#f3bc2c', contrastText: '#323c49' },
    info: { main: '#f1f5f9', light: '#f1f5f9', dark: '#8bb0d1', contrastText: '#323c49' },
    success: { main: '#e8f4ef', light: '#e8f4ef', dark: '#8ccaae', contrastText: '#323c49' },
    grey: {
      '50': '#F9FAFC',
      '100': '#F3F4F6',
      '200': '#536379',
      '300': palette.mooGrey,
      '400': '#434F61',
      '500': '#3A4655',
      '600': '#323C49',
      '700': '#2A333E',
      '800': '#212830',
      '900': '#171C22',
      A100: '#E8ECEE',
      A200: '#D6DDE1',
      A400: '#A8B7BE',
      A700: '#586368',
    },
    contrastThreshold: 3,
    tonalOffset: 0.2,
    text: {
      primary: '#323c49',
      secondary: palette.mooGrey,
      disabled: '#a9b1bc',
      hint: '#69778A',
    },
    divider: '#e9ecef',
    background: { paper: '#fff', default: '#fff', level2: '#e9ecef', level1: '#fff' },
    action: {
      active: palette.mooGreen,
      hover: '#E6F5F1',
      hoverOpacity: 0.04,
      selected: '#E6F5F1',
      selectedOpacity: 0.08,
      disabled: '#7e8a9b',
      disabledBackground: '#e9ecef',
      disabledOpacity: 0.38,
      focus: '#E6F5F1',
      focusOpacity: 0.12,
      activatedOpaciy: 0.12,
    },
  },
  shadows: [
    'none',
    '0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)',
    '0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)',
    '0px 3px 3px -2px rgba(0,0,0,0.2),0px 3px 4px 0px rgba(0,0,0,0.14),0px 1px 8px 0px rgba(0,0,0,0.12)',
    '0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)',
    '0px 3px 5px -1px rgba(0,0,0,0.2),0px 5px 8px 0px rgba(0,0,0,0.14),0px 1px 14px 0px rgba(0,0,0,0.12)',
    '0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)',
    '0px 4px 5px -2px rgba(0,0,0,0.2),0px 7px 10px 1px rgba(0,0,0,0.14),0px 2px 16px 1px rgba(0,0,0,0.12)',
    '0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12)',
    '0px 5px 6px -3px rgba(0,0,0,0.2),0px 9px 12px 1px rgba(0,0,0,0.14),0px 3px 16px 2px rgba(0,0,0,0.12)',
    '0px 6px 6px -3px rgba(0,0,0,0.2),0px 10px 14px 1px rgba(0,0,0,0.14),0px 4px 18px 3px rgba(0,0,0,0.12)',
    '0px 6px 7px -4px rgba(0,0,0,0.2),0px 11px 15px 1px rgba(0,0,0,0.14),0px 4px 20px 3px rgba(0,0,0,0.12)',
    '0px 7px 8px -4px rgba(0,0,0,0.2),0px 12px 17px 2px rgba(0,0,0,0.14),0px 5px 22px 4px rgba(0,0,0,0.12)',
    '0px 7px 8px -4px rgba(0,0,0,0.2),0px 13px 19px 2px rgba(0,0,0,0.14),0px 5px 24px 4px rgba(0,0,0,0.12)',
    '0px 7px 9px -4px rgba(0,0,0,0.2),0px 14px 21px 2px rgba(0,0,0,0.14),0px 5px 26px 4px rgba(0,0,0,0.12)',
    '0px 8px 9px -5px rgba(0,0,0,0.2),0px 15px 22px 2px rgba(0,0,0,0.14),0px 6px 28px 5px rgba(0,0,0,0.12)',
    '0px 8px 10px -5px rgba(0,0,0,0.2),0px 16px 24px 2px rgba(0,0,0,0.14),0px 6px 30px 5px rgba(0,0,0,0.12)',
    '0px 8px 11px -5px rgba(0,0,0,0.2),0px 17px 26px 2px rgba(0,0,0,0.14),0px 6px 32px 5px rgba(0,0,0,0.12)',
    '0px 9px 11px -5px rgba(0,0,0,0.2),0px 18px 28px 2px rgba(0,0,0,0.14),0px 7px 34px 6px rgba(0,0,0,0.12)',
    '0px 9px 12px -6px rgba(0,0,0,0.2),0px 19px 29px 2px rgba(0,0,0,0.14),0px 7px 36px 6px rgba(0,0,0,0.12)',
    '0px 10px 13px -6px rgba(0,0,0,0.2),0px 20px 31px 3px rgba(0,0,0,0.14),0px 8px 38px 7px rgba(0,0,0,0.12)',
    '0px 10px 13px -6px rgba(0,0,0,0.2),0px 21px 33px 3px rgba(0,0,0,0.14),0px 8px 40px 7px rgba(0,0,0,0.12)',
    '0px 10px 14px -6px rgba(0,0,0,0.2),0px 22px 35px 3px rgba(0,0,0,0.14),0px 8px 42px 7px rgba(0,0,0,0.12)',
    '0px 11px 14px -7px rgba(0,0,0,0.2),0px 23px 36px 3px rgba(0,0,0,0.14),0px 9px 44px 8px rgba(0,0,0,0.12)',
    '0px 11px 15px -7px rgba(0,0,0,0.2),0px 24px 38px 3px rgba(0,0,0,0.14),0px 9px 46px 8px rgba(0,0,0,0.12)',
  ],
  typography: {
    htmlFontSize: 16,
    fontFamily: '"Bryant MOO Pro Medium", "Trebuchet MS", Trebuchet, "Liberation Sans", sans-serif',
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
    body1: {
      fontFamily: '"Avenir Next Rounded Pro Regular", Verdana, Geneva, sans-serif',
      fontSize: 14,
      lineHeight: 1.15,
    },
    body2: {
      fontFamily: '"Avenir Next Rounded Pro Regular", Verdana, Geneva, sans-serif',
      fontSize: 14,
      lineHeight: 1.15,
    },
    h1: {
      fontFamily: '"Bryant MOO Pro Medium", "Trebuchet MS", Trebuchet, "Liberation Sans", sans-serif',
      fontWeight: 'normal',
      fontSize: '1.875rem',
      lineHeight: 1.15,
    },
    h2: {
      fontFamily: '"Bryant MOO Pro Medium", "Trebuchet MS", Trebuchet, "Liberation Sans", sans-serif',
      fontWeight: 'normal',
      fontSize: '1.5rem',
      lineHeight: 1.15,
    },
    h3: {
      fontFamily: '"Bryant MOO Pro Medium", "Trebuchet MS", Trebuchet, "Liberation Sans", sans-serif',
      fontWeight: 'normal',
      fontSize: '1.5rem',
      lineHeight: 1.15,
    },
    h4: {
      fontFamily: '"Bryant MOO Pro Medium", "Trebuchet MS", Trebuchet, "Liberation Sans", sans-serif',
      fontWeight: 'normal',
      fontSize: '1.3125rem',
      lineHeight: 1.15,
    },
    h5: {
      fontFamily: '"Bryant MOO Pro Medium", "Trebuchet MS", Trebuchet, "Liberation Sans", sans-serif',
      fontWeight: 'normal',
      fontSize: '1.3125rem',
      lineHeight: 1.15,
    },
    h6: {
      fontFamily: '"Bryant MOO Pro Medium", "Trebuchet MS", Trebuchet, "Liberation Sans", sans-serif',
      fontWeight: 'normal',
      fontSize: '1.125rem',
      lineHeight: 1.15,
    },
  },
  shape: { borderRadius: 4 },
  transitions: {
    easing: {
      easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
      easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
      easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
      sharp: 'cubic-bezier(0.4, 0, 0.6, 1)',
    },
    duration: {
      shortest: 150,
      shorter: 200,
      short: 250,
      standard: 300,
      complex: 375,
      enteringScreen: 225,
      leavingScreen: 195,
    },
  },
  zIndex: {
    mobileStepper: 1000,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500,
  },
  nprogress: { color: '#000' },
  props: {
    MuiButtonBase: {
      disableRipple: true,
    },
  },
  overrides: {
    MuiButtonBase: {
      root: {
        '&.Mui-focusVisible': {
          color: `${palette.mooGreen} !important`,
        },
        '&.Mui-selected.Mui-focusVisible': {
          // CSS specificity wars
          color: `${palette.mooGreen} !important`,
        },
      },
    },

    MuiOutlinedInput: {
      // https://github.com/mui-org/material-ui/blob/master/packages/material-ui/src/OutlinedInput/OutlinedInput.js
      root: {
        height: 40,
        backgroundColor: '#fff',
        '& $notchedOutline': {
          borderColor: '#dfe3e7',
        },
        '&$focused $notchedOutline': {
          borderWidth: 1,
        },
        '&:hover $notchedOutline': {
          borderColor: '#dfe3e7',
        },
      },
      input: {
        padding: '12px !important',
      },
      notchedOutline: {},
    },

    MuiFormControl: {
      root: {
        width: '100%',
      },
    },

    MuiSelect: {
      select: {
        minWidth: 212,
        '&:focus': {
          backgroundColor: '#fff',
        },
      },
      icon: {
        top: 'calc(50% - 11px)',
        width: 22,
        height: 22,
        fill: 'currentColor',
        transition: 'transform 0.2s linear',
      },
      iconOpen: {
        transform: 'scaleY(-1)',
      },
    },

    MuiMenuItem: {
      root: {
        minHeight: '40px !important',
      },
    },

    MuiSvgIcon: {
      root: {
        width: 22,
        height: 22,
      },
    },

    MuiAutocomplete: {
      inputRoot: {
        padding: '0 44px 0 0 !important', // make room for clear and open icons
      },
      option: {
        minHeight: '40px !important',
        overflow: 'hidden',
        wordBreak: 'break-all',
      },

      clearIndicator: {
        '&:hover': {
          backgroundColor: 'transparent',
        },
      },

      popupIndicator: {
        transition: 'transform 0.2s linear',
        '&:hover': {
          backgroundColor: 'transparent',
        },
      },
      popupIndicatorOpen: {
        transform: 'scaleY(-1)',
      },
    },

    MuiTabs: {
      root: {
        position: 'relative',
      },
      scrollButtonsDesktop: {
        display: 'inline-flex !important',
      },
      indicator: {
        transition: 'none',
      },
    },

    MuiTab: {
      root: {
        textTransform: 'none',
        minWidth: '0 !important',
        fontSize: 16,
        padding: '10px 0',
        textAlign: 'left',
        marginRight: 48,

        '&:after': {
          position: 'absolute',
          left: 0,
          bottom: 0,
          content: '" "',
          transform: 'scaleX(0)',
          transition: 'transform .25s',
          marginLeft: 0,
        },
        '&:hover:after': {
          width: '100%',
          height: '2px',
          transform: 'scaleX(1)',
          backgroundColor: palette.mooGreen,
        },

        '&$selected': {
          color: `${palette.mooGrey} !important`,
        },
      },

      textColorPrimary: {
        color: `${palette.mooGrey} !important`, // Overrides MBS a:hover style
      },

      wrapper: {
        alignItems: 'normal',
      },
    },
  },
};
